//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"ChamferOption",1,0],[0,"CreateAngleDimension",1,0],[0,"CreateDistance1Dimension",1,0],[0,"CreateDistance2Dimension",1,0],[1,"CurvesToChamfer",0,"SelectDisplayableObjectList",0],[1,"Distance1",0,"Expression",0],[1,"Distance2",0,"Expression",0],[0,"HelpPoint",1,"Point",0],[0,"TrimInputCurves",1,0]],[],[]];
SPLM.SketchChamferBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchChamferBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchChamferBuilder.ChamferOptions = Object.freeze({
    "Symmetric" : "Symmetric", "Asymmetric" : "Asymmetric", "OffsetandAngle" : "OffsetandAngle"});

export default SPLM;